<template>
  <div class="device">
    <div v-if="false">{{ userSelectAddressData }}</div>
    <div class="layout">
      <div class="device-setting">
        <div class="m16 pagination-bg-white device">
          <!-- 上半部分 -->
          <div
            class="flex"
            ref="topLine"
            style="border-bottom: 0.0625rem solid #ebebeb"
          >
            <div class="flex" style="width: 22.67%">
              <div style="width: 100%" class="bg-f p16 mr16 border-r-4">
                <p class="fs14 bold">
                  <i class="iconfont c-green mr10">&#xe616;</i>城市核定投放统计
                </p>
                <div v-show="checkUserAuth(64, 60)">
                  <div id="c3"></div>
                </div>
              </div>
            </div>
            <div class="flex" style="width: 34.33%">
              <div style="width: 100%" class="bg-f p16 mr16 border-r-4">
                <p class="fs14 bold">
                  <i class="iconfont c-blue mr10">&#xe616;</i>在线量占比统计
                </p>
                <div v-show="checkUserAuth(64, 60)">
                  <div id="c1"></div>
                </div>
              </div>
            </div>
            <div class="flex1 bg-f p16 border-r-4">
              <div style="width: 100%">
                <div class="flex justbetween mb10">
                  <p class="fs14 bold" style="width: 7.8125rem">
                    <i class="iconfont c-blue mr10">&#xe616;</i>站点排名分析
                  </p>
                  <div>
                    <el-button
                      v-show="checkUserAuth(64, 63) && isAggregation"
                      @click="onExportSite"
                      class="mr2"
                      size="mini"
                      type="primary"
                      style="background-color: #3e7878;border-color: #3e7878;">导出</el-button>
                    <el-radio-group
                      @change="onSiteType"
                      class="mr2"
                      size="mini"
                      v-model="siteType"
                      fill="#3e7878">
                      <el-radio-button label="时"></el-radio-button>
                      <el-radio-button label="日"></el-radio-button>
                      <el-radio-button label="月"></el-radio-button>
                    </el-radio-group>
                    <el-date-picker
                      :clearable="false"
                      class="datestyle"
                      size="mini"
                      v-model="siteRankAllTime"
                      @change="onSiteRankAllTime"
                      :type="
                        siteType === '时'
                          ? 'datetime'
                          : siteType === '日'
                          ? 'date'
                          : 'month'
                      "
                      popper-class="datestyle2"
                      placeholder="选择日期时间"
                      :format="
                        siteType === '时'
                          ? 'yyyy-MM-dd HH'
                          : siteType === '日'
                          ? 'yyyy-MM-dd'
                          : 'yyyy-MM'
                      "
                      default-time="12">
                    </el-date-picker>
                  </div>
                </div>
                <div class="table-height-limit" v-show="checkUserAuth(64, 59)">
                  <el-table
                    v-loading.body="tableLoading"
                    :data="tableData"
                    height="210px"
                    style="width: 99%"
                    @sort-change="handleSortChange"
                    class="site_ranking_table"
                    highlight-current-row>
                    <el-table-column prop="index" label="排名" align="center">
                      <template v-slot="props">
                        <span> {{ props.$index + 1 }} </span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="siteName" width="200" label="站点名称" align="center">
                      <template v-slot="props">
                        <span @click="jjSearch(props.row)" class="blue pointer">
                          {{ props.row["siteName"] }}
                        </span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="rentNum" sortable label="租车" align="center"/>
                    <el-table-column prop="returnNum" sortable label="还车" align="center"/>
                    <el-table-column prop="upNum" sortable label="上架" align="center"/>
                    <el-table-column prop="downNum" sortable label="下架" align="center"/>
                  </el-table>
                  <div v-show="!checkUserAuth(3, 16)">
                    您的账户没有权限查看此内容！
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 下半部分 -->
          <div class="mt16 flex" :style="{ height: (realHeight) / 16 + 'rem' }">
            <div class="flex1 p16 border-r-4 bg-f mr16">
              <div style="width: 100%">
                <div class="flex justbetween mb20">
                  <p class="fs14 bold">
                    <i class="iconfont c-blue mr10">&#xe616;</i>潮汐统计
                  </p>
                  <div>
                    <el-button
                      @click="goRequestSyncPage('requestSync', { timeType: '1' })"
                      class="mr2"
                      size="mini"
                      type="primary"
                      style="background-color: #3e7878;border-color: #3e7878;">数据详情</el-button>
                    <el-select
                      v-if="dataType === '年'"
                      @change="onSelectYear"
                      size="mini"
                      v-model="selectYear"
                      style="width: 100px;float: left;margin-right: 10px;"
                      placeholder="请选择">
                      <el-option
                        v-for="item in selectYears"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                    <el-radio-group
                      @change="onDataType"
                      size="mini"
                      v-model="dataType"
                      fill="#3e7878">
                      <el-radio-button label="日"></el-radio-button>
                      <el-radio-button label="月"></el-radio-button>
                      <el-radio-button label="年"></el-radio-button>
                    </el-radio-group>
                  </div>
                </div>
                <!-- 动态数据展示区：租车 / 还车 / 上架 / 下架 -->
                <div
                  class="dynamic-show"
                  v-if="dynamicTotalShowData && dynamicTotalShowData.length"
                >
                  <div
                    class="dynamic-item"
                    v-for="(item, index) in dynamicTotalShowData"
                    :key="'total' + item.name + index"
                    @click="onSwitchTidalType(item.name)"
                    :class="{ 'active-total': currentTidalType === item.name }"
                  >
                    <p class="num" :class="{ blue: !index }">
                      <animate-number
                        :from="item.from"
                        :to="item.to"
                        :duration="item.duration"
                        easing="easeOutQuad"
                        :formatter="animateNumberFormatter"
                      >
                      </animate-number>
                    </p>
                    <p class="name">{{ item.name }}</p>
                  </div>
                </div>
                <template>
                  <div id="c2" v-show="checkUserAuth(64, 134)"></div>
                </template>
              </div>
            </div>
            <div style="width: 43%">
              <div
                style="height: 100%; box-sizing: border-box"
                class="p16 border-r-4 bg-f">
                <total-sum-chart
                  @explorer="onExportLogShowModel(4, $event)"
                  v-show="checkUserAuth(64, 134)"
                  :isAggregation="isAggregation"
                  :selfAreaId="selfAreaId"
                  :realHeight="realHeight">
                  <div class="mb20 title" slot="title">
                    <p class="fs14 bold">
                      <i class="iconfont c-blue mr10">&#xe616;</i>品牌车辆状态统计
                    </p>
                  </div>
                </total-sum-chart>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 一级弹窗 -->
    <w-dialog
      ref="w-dialog-month"
      :title="dialogTitleMonth"
      width="90%"
      :isShowFooter="false"
      @handleCloseRight="handleCloseMonth">
      <template v-slot:content>
        <div id="cMonth"></div>
      </template>
    </w-dialog>
    <w-dialog
      ref="w-dialog-day"
      :title="dialogTitleDay"
      width="85%"
      :isShowFooter="false"
      @handleCloseRight="handleCloseDay">
      <template v-slot:content>
        <div id="cDay"></div>
      </template>
    </w-dialog>
    <w-dialog
      width="60%"
      ref="export-log"
      title="导出设置"
      sureBtnText="导出"
      @handleCloseRight="handleCloseExportLog"
      @handleClose="handleCloseExportLog"
      @onSure="onExportLogPre">
      <template v-slot:content>
        <el-form ref="form" :model="form" label-width="6.25rem">
          <el-form-item label="品牌选择：">
            <el-checkbox-group size="mini" v-model="pinpai">
              <el-checkbox
                :label="item"
                :key="item"
                v-for="item in pinpaiNames"/>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="导出时间：" v-if="exportLogType === 2">
            <el-date-picker
              size="mini"
              v-model="exportTime"
              type="date"
              placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="合法性" v-if="exportLogType === 3">
            <el-radio-group v-model="legality">
              <el-radio :label="null">全部</el-radio>
              <el-radio :label="0">合法</el-radio>
              <el-radio :label="1">非法</el-radio>
            </el-radio-group>
          </el-form-item>
          <template v-if="exportLogType === 1">
            <el-form-item label="导出时间：">
              <template v-if="dataType === '日'">
                <el-date-picker
                  size="mini"
                  v-model="exportTime"
                  type="date"
                  placeholder="选择日期"
                  format="yyyy-MM-dd">
                </el-date-picker>
              </template>
              <template v-if="dataType === '月'">
                <el-date-picker
                  size="mini"
                  v-model="exportTime"
                  type="month"
                  placeholder="选择月"
                  format="yyyy-MM">
                </el-date-picker>
              </template>
              <template v-if="dataType === '年'">
                <el-date-picker
                  size="mini"
                  v-model="exportTime"
                  type="year"
                  placeholder="选择年"
                  format="yyyy">
                </el-date-picker>
              </template>
            </el-form-item>
            <el-form-item label="车辆状态：">
              <el-radio-group size="mini" v-model="exportLogAction">
                <el-radio-button label="全部"></el-radio-button>
                <el-radio-button label="下架"></el-radio-button>
                <el-radio-button label="上架"></el-radio-button>
              </el-radio-group>
            </el-form-item>
          </template>
          <template v-if="exportLogType === 4">
            <el-form-item label="导出时间：">
              <template v-if="logType === '日'">
                <el-time-picker
                  style="width: 200px"
                  is-range
                  size="mini"
                  v-model="exportTime"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  type="date"
                  format="HH:mm:ss">
                </el-time-picker>
              </template>
              <template v-if="logType === '月'">
                <el-date-picker
                  style="width: 200px"
                  size="mini"
                  v-model="exportTime"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  format="yyyy-MM-dd">
                </el-date-picker>
              </template>
              <template v-if="logType === '年'">
                <el-date-picker
                  style="width: 200px"
                  size="mini"
                  type="monthrange"
                  v-model="exportTime"
                  range-separator="至"
                  start-placeholder="开始月份"
                  end-placeholder="结束月份"
                  format="yyyy-MM">
                </el-date-picker>
              </template>
            </el-form-item>
            <el-form-item label="导出数据：">
              <el-radio-group v-model="logData" size="mini">
                <el-radio-button label="1">投放量</el-radio-button>
                <el-radio-button label="2">入栏量</el-radio-button>
                <el-radio-button label="3">活跃量</el-radio-button>
                <el-radio-button label="4">调度率</el-radio-button>
                <el-radio-button label="5">周转率</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </template>
        </el-form>
      </template>
    </w-dialog>
  </div>
</template>

<script>
import WTable from '@/components/Table/index.vue'
import WDialog from '@/components/Model/index.vue'
import { Chart, registerShape } from '@antv/g2'
import { Line } from '@antv/g2plot'
import Api from '@/api'
import { mapGetters } from 'vuex'
import staticData from './staticData.js'
import store from '@/store'
import AnimateNumber from './components/AnimateNumber'
import totalSumChart from './components/totalSumChart'

import { Loading } from 'element-ui'

export default {
  name: 'operation',
  data() {
    return {
      loading: false,
      originColors: [],
      pinpaiSort: [],
      // 单车品牌颜色
      brandOriginColor: {},
      // 电动车品牌颜色
      eOriginColor: {},
      // 美团电单
      // 青桔电单
      pSort: {},
      tableLoading: false,
      siteRankAllTime: new Date(),
      tableData: null,
      total: 0,
      tidalData: null,
      tidalDataDays: null,
      tidalDataMonths: null,
      brandIds: [],
      action: '租还', // 0-租车，1-还车
      dataType: '日', // 0-日，1-月，2-年
      chart: null, // 潮汐
      chartDays: null,
      chartMonths: null,
      selectYear: undefined,
      selectYears: [],
      dialogTitleDay: '',
      dialogTitleMonth: '',
      monthCache: null,
      pinpai: [],
      legality: null,
      pinpaiNames: [],
      realNames: [], // 每个品牌
      rentReturnBrandNames: [], // 租还品牌名称
      exportTime: new Date(),
      form: {},
      Circle1: null,
      Circle3: null,
      brandPercentData: [],
      realPinpaiNames: [],
      realHeight: 0,
      siteType: '日',
      timer: null,
      fullPileNumPage: 0,
      exportLogType: null,
      exportLogAction: '全部',
      logType: '日',
      logData: '5',
      selfAreaIdOrAggregationId: '',
      preDynamicData: undefined,
      dynamicAllToatal: {
        rent: 0,
        return: 0,
        up: 0,
        down: 0
      },
      dynamicTotalData: [],
      dynamicPinPaiNames: [],
      dynamicTotalByTime: undefined,
      // 动态数据展示
      dynamicOldestRentData: [],
      dynamicOldRentData: [],
      dynamicRentData: [],
      dynamicRentShowData: [],
      dynamicOldestReturnData: [],
      dynamicOldReturnData: [],
      dynamicReturnData: [],
      dynamicReturnShowData: [],
      getDynamicDataShowIndex: 1,
      getDynamicDispatchDataShowIndex: 1,
      dynamicUpData: [],
      dynamicDownData: [],
      dynamicUpShowData: [],
      dynamicDownShowData: [],
      dynamicTimer: null,
      dynamicApiParams: undefined,
      orderBy: 'rent_num desc',
      // 租车/还车/上架/下架 四个总量
      dynamicTotalShowData: [],
      // null 表示默认（现有逻辑）；'租车总量' / '还车总量' / '上架总量' / '下架总量'
      currentTidalType: null
    }
  },
  computed: {
    // vue-animate-number
    ...mapGetters([
      'userSelectAddressData',
      'user',
      'selfAreaId',
      'permissions',
      'userLevel',
      'currpath',
      'fullPileNum',
      'fullPileName',
      'userBikeType'
    ]),
    isAggregation() {
      // 是否是非复合区下的实体区
      if (this.aggregation !== undefined && this.userLevel > 1) {
        if (this.aggregation === 0 && this.aggregationId) {
          return false // 复合区下的区含有标识mold=1
        } else if (this.aggregation === 1 && this.aggregationId) {
          return true // 复合区不含有标识mold=1
        } else {
          return true
        }
      } else {
        return true
      }
    },
    staticData() {
      return staticData
    },
    aggregationId() {
      // 实体区的复合区Id
      return this.userSelectAddressData
        ? this.userSelectAddressData.aggregationId
        : undefined
    },
    aggregation() {
      // 0 - 实体区
      return this.userSelectAddressData
        ? this.userSelectAddressData.aggregation
        : undefined
    },
    isBicycle() {
      // 判断用户账号属性为自行车或者包含电动车及自行车
      return (this.userBikeType === 0 || this.userBikeType === 2)
    },
    isElectricBike() {
      // 判断用户账号属性为电动车或者包含电动车及自行车
      return (this.userBikeType === 1 || this.userBikeType === 2)
    }
  },
  watch: {
    fullPileNum(val) {
      this.fullPileNumPage = val
    }
  },
  created() {
    this.yearChange()
    this.selfAreaIdOrAggregationId = this.selfAreaId
    document.addEventListener(
      'click',
      (e) => {
        clearTimeout(this.timer)
        this.timer = null
      },
      false
    )
    this.getAreaBrandDetails()
  },
  mounted() {
    const vm = this
    vm.fullPileNumPage = vm.fullPileNum
    vm.setPollingMap()
    vm.preDestroy && vm.preDestroy()
  },
  beforeDestroy() {
    const vm = this
    clearTimeout(vm.timer)
    vm.timer = null
    clearTimeout(vm.dynamicTimer)
    vm.dynamicTimer = null

    document.removeEventListener('click', vm.handler, false)
  },
  methods: {
    yearChange () {
      var newDate = new Date()
      var startYear = newDate.getFullYear() - 4// 起始年份
      var endYear = newDate.getFullYear() // 结束年份
      this.selectYears = []
      for (var i = startYear; i <= endYear; i++) {
        this.selectYears.push({
          value: (i + ''),
          label: (i + '年')
        })
      }
      this.selectYears.sort((a, b) =>
        a.value < b.value ? 1 : a.value > b.value ? -1 : 0
      )
    },
    // 统计图汇总区域品牌信息
    getAreaBrandDetails() {
      const params = {
        selfAreaId: this.selfAreaId
      }
      Api.areaBrandDetails(params).then((res) => {
        if (res.code === 200) {
          res.data.forEach(item => {
            this.originColors.push(item.bikeColor)
            this.pinpaiSort.push(item.brandName)
          })
          const brandOriginColor = res.data.map(item => {
            return {
              brandName: item.brandName.slice(0, 2) + '单车',
              bikeColor: item.bikeColor
            }
          })
          // 单车
          const colorObject = brandOriginColor => {
            for (let i = 0; i < brandOriginColor.length; i++) {
              const { brandName, bikeColor } = brandOriginColor[i]
              this.brandOriginColor[brandName] = bikeColor
            }
            return this.brandOriginColor
          }
          this.brandOriginColor = colorObject(brandOriginColor)
          // 电动车
          const eBrandOriginColor = res.data.map(item => {
            if (item.brandName.indexOf('美团出行') > -1) {
              return {
                brandName: '美团电单',
                eBikeColor: item.ebikeColor
              }
            }
            return {
              brandName: item.brandName,
              eBikeColor: item.ebikeColor
            }
          })
          const eColorObject = eBrandOriginColor => {
            for (let i = 0; i < eBrandOriginColor.length; i++) {
              const { brandName, eBikeColor } = eBrandOriginColor[i]
              this.eOriginColor[brandName] = eBikeColor
            }
            return this.eOriginColor
          }
          this.eOriginColor = eColorObject(eBrandOriginColor)
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    animateNumberFormatter: function (num) {
      return num.toFixed(0)
    },
    handler() {
      const vm = this
      clearTimeout(vm.timer)
      vm.timer = null
      clearTimeout(vm.dynamicTimer)
      vm.dynamicTimer = null
    },
    async setPollingMap() {
      const vm = this
      const hasLength = await vm.getEnterpriseListAndHasLength()
      if (!hasLength && vm.aggregation === 0) {
        vm.selfAreaIdOrAggregationId = vm.aggregationId
      } else {
        vm.selfAreaIdOrAggregationId = vm.selfAreaId
      }
      vm.initPolling()
      vm.timer = setTimeout(vm.setPollingMap, 1000 * 60 * 30) // 30分钟
      // store.dispatch('user/setSideBarLoading', {
      //   key: 'sideBarLoading',
      //   value: true
      // }).then(() => {
      //   vm.timer = setTimeout(vm.setPollingMap, 1000 * 20) // 1分钟
      // })
    },
    async initPolling() {
      const vm = this
      if (Number(this.userLevel) === 2) {
        // 排名
        vm.siteRankAll(true)
        // 品牌占比
        await vm.initCircle1DataNew()
        // await vm.initCircle1DataNew();
        // 潮汐
        vm.tidal(null, null, null, null, null)
        // 城市核定投放统计
        // vm.initCircle3Data();
      }
      vm.$nextTick(() => {
        vm.calculateHeight()
        store
          .dispatch('user/setSideBarLoading', {
            key: 'sideBarLoading',
            value: false
          })
          .then(() => {})
      })
    },
    jjSearch(item) {
      const vm = this
      if (item.siteId) {
        const loadingInstance = Loading.service({
          fullscreen: true,
          text: '站点搜索中...'
        })
        if (vm.currpath.indexOf('index') === -1) {
          loadingInstance.close()
          store.commit('user/setUserInfo', {
            key: 'siteId',
            value: item.siteId
          })
          vm.$router.push(
            '/index' +
            (vm.currpath.split('/')[2]
              ? '/' + vm.currpath.split('/')[2]
              : '')
          )
        }
      } else {
        vm.$message.warning('该条数据存在问题，没有车辆编号！')
      }
    },
    onSiteType() {
      this.onSiteRankAllTime()
    },
    calculateHeight() {
      if (
        this.$refs.topLine &&
        window.innerHeight > this.$refs.topLine.clientHeight
      ) {
        this.realHeight =
          window.innerHeight - this.$refs.topLine.clientHeight - 100
      } else {
        this.realHeight = 500
      }
    },
    handleCloseMonth() {
      this.monthCache = null
      this.$refs['w-dialog-month'].onCloseDialog()
    },
    handleCloseDay() {
      this.$refs['w-dialog-day'].onCloseDialog()
    },
    onClickPoint(data) {
      const vm = this
      if (vm.dataType === '时') {
      } else if (data.label === '日') {
        vm.dialogTitleDay =
          new Date().getFullYear() +
          '-' +
          (new Date().getMonth() + 1) +
          '-' +
          data.key +
          ' 曲线图'
        vm.$refs['w-dialog-day'].onShowDialog()
        vm.$nextTick(() => {
          vm.tidal(null, data, 'cDay', 'tidalDataDays', 'chartDays')
        })
      } else if (data.label === '月') {
        vm.monthCache = Number(data.key) < 10 ? '0' + data.key : data.key
        if (vm.selectYear) {
          vm.dialogTitleMonth = vm.selectYear + '-' + data.month + ' 曲线图'
        } else {
          vm.dialogTitleMonth =
            new Date().getFullYear() + '-' + data.month + ' 曲线图'
        }
        vm.$refs['w-dialog-month'].onShowDialog()
        vm.$nextTick(() => {
          vm.tidal(null, data, 'cMonth', 'tidalDataMonths', 'chartMonths')
        })
      }
    },
    onSelectYear() {
      this.onResetTide()
      this.tidal(true, null, null, null, null)
    },
    onResetTide() {
      this.dynamicRentData = []
      this.dynamicOldRentData = []
      this.dynamicOldestRentData = []
      this.dynamicReturnData = []
      this.dynamicOldReturnData = []
      this.dynamicOldestReturnData = []
      this.dynamicUpData = []
      this.dynamicDownData = []
      this.dynamicUpShowData = []
      this.dynamicDownShowData = []
    },
    onDataType() {
      this.dynamicRentData = []
      this.dynamicOldRentData = []
      this.dynamicOldestRentData = []
      this.dynamicReturnData = []
      this.dynamicOldReturnData = []
      this.dynamicOldestReturnData = []
      this.selectYear = undefined
      if (this.dataType === '年') {
        this.selectYear = this.selectYear ?? this.selectYears[0].value
      }
      this.tidal(null, null, null, null, null)
    },
    getDuration() {
      // 3-10秒
      return 5 * 1000
      // return Math.floor(Math.random() * 7 + 3) * 1000
    },
    getLabelName(key, type, vehicleType) {
      // type: 1-租车，2-还车
      // vehicleType: 1-单车，2-电车
      if (key === '美团电单') {
        if (vehicleType === 1) {
          if (type === 1) {
            return '美团单车(租车)'
          } else if (type === 2) {
            return '美团单车(还车)'
          }
        } else if (vehicleType === 2) {
          if (type === 1) {
            return '美团电单(租车)'
          } else if (type === 2) {
            return '美团电单(还车)'
          }
        }
      }
      if (key === '哈啰电单') {
        if (vehicleType === 1) {
          if (type === 1) {
            return '哈啰单车(租车)'
          } else if (type === 2) {
            return '哈啰单车(还车)'
          }
        } else if (vehicleType === 2) {
          if (type === 1) {
            return '哈啰电单(租车)'
          } else if (type === 2) {
            return '哈啰电单(还车)'
          }
        }
      }
      if (type === 1) {
        return `${key}(租车)`
      } else if (type === 2) {
        return `${key}(还车)`
      }
    },
    translateData(data) {
      let i = 1
      for (const key of this.pinpaiSort) {
        this.pSort[i + key] = data[key]
        i++
      }
    },
    translateData2(data) {
      let i = 1
      const pSort = {}
      for (const key of this.pinpaiSort) {
        pSort[i + key] = data[key]
        i++
      }
      return pSort
    },
    getDynamicDataShow() {
      this.dynamicRentData = []
      this.dynamicReturnData = []
      this.getDynamicDataShowIndex += 10

      // 重置展示数据
      this.dynamicRentShowData = []
      this.dynamicReturnShowData = []

      // 只处理租车和还车的总量数据（不处理各品牌明细）
      if (this.action === '租车' || this.action === '租还') {
        // 租车总量
        this.dynamicRentData.push({
          name: '租车总量',
          from: 0,
          to: this.dynamicAllToatal.rent,
          duration: 6000
        })
      }

      if (this.action === '还车' || this.action === '租还') {
        // 还车总量
        this.dynamicReturnData.push({
          name: '还车总量',
          from: 0,
          to: this.dynamicAllToatal.return,
          duration: 6000
        })
      }

      // 初始化展示数据
      this.initShowData(
        this.dynamicRentData,
        this.dynamicOldestRentData,
        this.dynamicOldRentData,
        'dynamicRentShowData'
      )
      this.initShowData(
        this.dynamicReturnData,
        this.dynamicOldestReturnData,
        this.dynamicOldReturnData,
        'dynamicReturnShowData'
      )
    },
    initShowData(sourceData, oldestData, oldData, showDataKey) {
      if (sourceData.length && !oldestData.length && !oldData.length) {
        const filtered = sourceData.filter(item => item.to !== 0)
        oldestData.push(...filtered)
        oldData.push(...filtered)
        this[showDataKey] = filtered
      }
    },
    createDataDispatchItem(key, type, vehicleType, value) {
      return {
        name: this.getLabelDispatchName(key, type, vehicleType),
        from: 0,
        to: value,
        duration: this.getDuration()
      }
    },
    getLabelDispatchName(key, type, vehicleType) {
      // type: 1-上架，2-下架
      // vehicleType: 1-单车，2-电车
      if (key === '美团电单') {
        if (vehicleType === 1) {
          if (type === 1) {
            return '美团单车(上架)'
          } else if (type === 2) {
            return '美团单车(下架)'
          }
        } else if (vehicleType === 2) {
          if (type === 1) {
            return '美团电单(上架)'
          } else if (type === 2) {
            return '美团电单(下架)'
          }
        }
      }
      if (key === '哈啰电单') {
        if (vehicleType === 1) {
          if (type === 1) {
            return '哈啰单车(上架)'
          } else if (type === 2) {
            return '哈啰单车(下架)'
          }
        } else if (vehicleType === 2) {
          if (type === 1) {
            return '哈啰电单(上架)'
          } else if (type === 2) {
            return '哈啰电单(下架)'
          }
        }
      }
      if (type === 1) {
        return `${key}(上架)`
      } else if (type === 2) {
        return `${key}(下架)`
      }
    },
    addTotalDispatchData() {
      if (this.action === '上架' || this.action === '上下架') {
        this.dynamicUpData.unshift({
          name: '上架总量',
          from: 0,
          to: this.dynamicAllToatal.up,
          duration: 6000
        })
      }
      if (this.action === '下架' || this.action === '上下架') {
        this.dynamicDownData.unshift({
          name: '下架总量',
          from: 0,
          to: this.dynamicAllToatal.down,
          duration: 6000
        })
      }
    },
    initShowDispatchData() {
      if (this.dynamicUpData.length) {
        this.dynamicUpShowData = this.dynamicUpData.filter(item => item.to !== 0)
      }
      if (this.dynamicDownData.length) {
        this.dynamicDownShowData = this.dynamicDownData.filter(item => item.to !== 0)
      }
    },
    sliceDate(params, data) {
      // 如果在本月本日本年 过滤掉 超过当前期限的数据
      const today = new Date()
      let slicelength = 0
      if (params.year === today.getFullYear() && !params.month) {
        slicelength = today.getMonth() + 1
      }
      if (params.month === today.getMonth() + 1 && !params.day) {
        slicelength = today.getDate()
      }
      if (params.day === today.getDate()) {
        slicelength = today.getHours() + 1
      }
      if (slicelength) {
        for (const key in data) {
          if (data[key].length > 0) {
            data[key] = data[key].slice(0, slicelength)
            if (data[key].slice(-1)[0].num === 0) {
              data[key].splice(-1)
            }
          }
        }
      }
      return data
    },
    getDynamicApi() {
      const vm = this
      Api.tidal2(vm.dynamicApiParams)
        .then((res) => {
          if (res.code === 200) {
            vm.dynamicTotalData = []
            if (vm.dataType === '月') {
              const filledData = this.fillDates(res.data)
              res.data = filledData
            }
            res.data = this.sliceDate(vm.dynamicApiParams, res.data)

            // 重置总量数据
            vm.dynamicAllToatal = { rent: 0, return: 0, up: 0, down: 0 }

            // 只统计总量，不保存明细
            for (const pinpaiName in res.data) {
              const pinpai = res.data[pinpaiName]
              let bikeRentNumTotal = 0
              let bikeReturnNumTotal = 0
              let eBikeRentNumTotal = 0
              let eBikeReturnNumTotal = 0

              for (const p of pinpai) {
                if (this.isBicycle) {
                  bikeRentNumTotal += p.bike_rent_num || 0
                  bikeReturnNumTotal += p.bike_return_num || 0
                }
                if (this.isElectricBike) {
                  eBikeRentNumTotal += p.e_bike_rent_num || 0
                  eBikeReturnNumTotal += p.e_bike_return_num || 0
                }
              }
              vm.dynamicAllToatal.rent += bikeRentNumTotal + eBikeRentNumTotal
              vm.dynamicAllToatal.return += bikeReturnNumTotal + eBikeReturnNumTotal
            }

            // 调用数据展示
            vm.getDynamicDataShow()

            clearTimeout(vm.dynamicTimer)
            vm.dynamicTimer = null
            vm.dynamicTimer = setTimeout(vm.getDynamicApi, 1000 * 20)
          } else {
            vm.$message.warning(res.message)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 潮汐统计月租还数据，自动补充未补齐月份当中的日期数据
    fillDates(data) {
      const endDateObj = new Date() // 当前日期即结束日期
      let earliestDate = endDateObj // 假设最早日期是结束日期
      // 找到所有子数组中的最早日期
      Object.keys(data).forEach(key => {
        data[key].forEach(item => {
          const itemDate = new Date(item.date)
          if (itemDate < earliestDate) {
            earliestDate = itemDate
          }
        })
      })
      earliestDate = earliestDate.toISOString().split('T')[0] // 转换回 YYYY-MM-DD 格式
      // 处理每个子数组
      const result = {}
      Object.keys(data).forEach(key => {
        const filledItems = []
        // 生成从最早日期到结束日期的完整列表
        const currentDate = new Date(earliestDate)
        while (currentDate <= endDateObj) {
          const currentDateString = currentDate.toISOString().split('T')[0]
          const existingItem = data[key].find(item => item.date === currentDateString)
          filledItems.push(existingItem || { date: currentDateString, bike_return_num: 0, bike_rent_num: 0, e_bike_return_num: 0, e_bike_rent_num: 0 })
          currentDate.setDate(currentDate.getDate() + 1)
        }
        result[key] = filledItems
      })
      return result
    },
    async tidal(isYearChange, data, id, originDataName, chartName) {
      const vm = this
      vm.loading = true
      const format = vm.selectYear
        ? vm.getSiteParams(vm.selectYear)
        : vm.getSiteParams()
      const params = {
        selfAreaId: !this.isAggregation
          ? this.selfAreaId
          : vm.selfAreaIdOrAggregationId,
        year: format[0],
        action: '租还',
        dataType: vm.dataType
      }
      if (!this.isAggregation) {
        params.mold = 1
      }
      if (this.dataType === '日') {
        params.month = format[1]
        params.day = format[2]
      } else if (this.dataType === '月') {
        params.month = format[1]
      }
      // 浮层数据获取参数
      if (data && data.month) {
        if (data.label === '日') {
          params.year = this.selectYear ? this.selectYear : new Date().getFullYear()
          params.month = this.monthCache
            ? this.monthCache
            : new Date().getMonth() < 9
              ? '0' + (new Date().getMonth() + 1)
              : new Date().getMonth() + 1
          params.day = Number(data.key) < 10 ? '0' + data.key : data.key
        } else if (data.label === '月') {
          params.year = this.selectYear ? this.selectYear : new Date().getFullYear()
          params.month = Number(data.key) < 10 ? '0' + data.key : data.key
        }
      }

      try {
        // 并行请求：租还 + 上下架
        const upDownParams = { ...params, action: '上下架' }
        const [rentReturnRes, upDownRes] = await Promise.all([
          Api.tidal2(params),
          Api.tidal2(upDownParams)
        ])

        if (rentReturnRes.code !== 200) {
          vm.$message.warning(rentReturnRes.message)
          return
        }

        // 合并租还 + 上下架数据
        let mergedData = this.mergeTidalData(
          rentReturnRes.data || {},
          upDownRes && upDownRes.code === 200 ? upDownRes.data || {} : {}
        )

        mergedData = this.sliceDate(params, mergedData)
        vm.pinpaiSort = vm.getPinpaiSort(mergedData)
        vm.dynamicTotalData = []
        vm.translateData(mergedData)

        // 动态数据展示：租车/还车/上架/下架
        vm.onResetTide()
        vm.translateTotalDynamicData(mergedData)
        vm.getTotalDynamicDataShow()

        if (data && data.month) {
          vm[originDataName] = this.pSort
          if (vm[chartName]) {
            vm[chartName].destroy()
          }
          vm.$nextTick(() => {
            vm.initScale(id, originDataName, chartName, data)
          })
          return
        }
        vm.tidalData = this.pSort
        vm.getpinpai()
        if (vm.chart) {
          vm.chart.destroy()
          vm.chart = null
        }
        vm.$nextTick(() => {
          vm.initScale(null, 'tidalData', 'chart', null)
        })
      } catch (err) {
        console.log(err)
      }
    },
    getpinpai() {
      const vm = this
      vm.pinpaiNames = []
      for (const key in vm.tidalData) {
        vm.pinpaiNames.push(key.slice(1))
      }
    },
    getScaleData(originDateName, id, pargetPoint) {
      const data = []
      this.realPinpaiNames = []
      this.dynamicPinPaiNames = []
      if (id) {
        if (pargetPoint.label === '月') {
          for (const key in this[originDateName]) {
            data.push(
              ...this.objectToArrayFromMonth(this[originDateName][key], key)
            )
          }
        } else if (pargetPoint.label === '日') {
          for (const key in this[originDateName]) {
            data.push(
              ...this.objectToArrayFromHours(this[originDateName][key], key)
            )
          }
        }
        return data
      }
      if (this.dataType === '日') {
        // 小时
        for (const key in this[originDateName]) {
          data.push(
            ...this.objectToArrayFromHours(this[originDateName][key], key)
          )
        }
      } else if (this.dataType === '月') {
        // 天
        for (const key in this[originDateName]) {
          data.push(
            ...this.objectToArrayFromMonth(this[originDateName][key], key)
          )
        }
      } else if (this.dataType === '年') {
        // 月
        for (const key in this[originDateName]) {
          data.push(
            ...this.objectToArrayFromYear(this[originDateName][key], key)
          )
        }
      }
      return data
    },
    getAction(key) {
      const names = []
      const bpre = key.slice(1, 3)
      const epro = key.slice(1)
      const targetPinpai = this.brandPercentData[key.slice(1)]
      const hasBike =
        targetPinpai &&
        targetPinpai.PutBikeNumOrigin + targetPinpai.BrandBikeNum > 0
      const hasEBike =
        targetPinpai &&
        targetPinpai.PutEBikeNumOrigin + targetPinpai.BrandEBikeNum > 0

      // 固定四类
      if (this.isElectricBike) {
        if (hasEBike) {
          if (epro === '美团出行') {
            names.push('美团电单(租车)')
            names.push('美团电单(还车)')
            names.push('美团电单(上架)')
            names.push('美团电单(下架)')
          } else {
            names.push(`${epro}(租车)`)
            names.push(`${epro}(还车)`)
            names.push(`${epro}(上架)`)
            names.push(`${epro}(下架)`)
          }
        }
      }
      if (this.isBicycle) {
        if (hasBike) {
          names.push(`${bpre}单车(租车)`)
          names.push(`${bpre}单车(还车)`)
          names.push(`${bpre}单车(上架)`)
          names.push(`${bpre}单车(下架)`)
        }
      }

      this.dynamicPinPaiNames.push(...names)
      this.realPinpaiNames.push(names.length)
      this.rentReturnBrandNames = Object.assign(this.dynamicPinPaiNames)
      return names
    },
    objectToArrayFromHours(items, key) {
      const arrs = []
      const names = this.getAction(key)
      for (const item of items) {
        for (const name of names) {
          const o = {}
          o[item.hour] = item.hour
          o.city = name
          o.month = item.hour + '点'
          o.temperature = this.getTemperature(item, name)
          o.key = item.hour
          o.label = '时'
          o.date = item.date   // 新增：把 date 带上
          arrs.push(o)
        }
      }
      return arrs
    },
    objectToArrayFromMonth(items, key) {
      const arrs = []
      const names = this.getAction(key)
      for (const item of items) {
        for (const name of names) {
          const day = Number(item.date.split('-')[2])
          const o = {}
          o[day] = day
          o.city = name
          o.month = Number(day) < 10 ? '0' + day : String(day)
          o.temperature = this.getTemperature(item, name)
          o.key = day
          o.label = '日'
          o.date = item.date   // ← 新增
          arrs.push(o)
        }
      }
      return arrs
    },
    getTitle(item, totalTemperature) {
      const rent = totalTemperature.totalZhuCheTemperature || 0
      const ret = totalTemperature.totalHuanCheTemperature || 0
      const up = totalTemperature.totalUpTemperature || 0
      const down = totalTemperature.totalDownTemperature || 0

      let timeLabel = ''
      if (this.dataType === '日') {
        // 日模式
        timeLabel = `${this.formatDateCN(item.date)} ${item.key}点`
      } else if (this.dataType === '月') {
        // 月模式
        timeLabel = this.formatDateCN(item.date)
      } else if (this.dataType === '年') {
        // 年模式
        timeLabel = this.formatMonthCN(item.date)
      }
      return `${timeLabel} 租车总量：${rent} 还车总量：${ret} 上架总量：${up} 下架总量：${down}`
    },
    formatDateCN(dateStr) {
      if (!dateStr) return ''
      const s = String(dateStr).slice(0, 10)
      const [y, m, d] = s.split('-')
      if (!y || !m || !d) return s
      return `${Number(y)}年${Number(m)}月${Number(d)}日`
    },
    formatMonthCN(dateStr) {
      if (!dateStr) return ''
      const s = String(dateStr).slice(0, 7)
      const [y, m] = s.split('-')
      if (!y || !m) return s
      return `${Number(y)}年${Number(m)}月`
    },
    objectToArrayFromYear(items, key) {
      const arrs = []
      const names = this.getAction(key)
      for (const item of items) {
        for (const name of names) {
          const month = Number(item.date.split('-')[1])
          const o = {}
          o[month] = month
          o.city = name
          o.month = month + '月'
          o.temperature = this.getTemperature(item, name)
          o.key = month
          o.label = '月'
          o.date = item.date
          arrs.push(o)
        }
      }
      return arrs
    },
    getTemperature(item, name) {
      const rentReturnMap = {
        '出行(租车)': 'e_bike_rent_num',
        '出行(还车)': 'e_bike_return_num',
        '单车(租车)': 'bike_rent_num',
        '单车(还车)': 'bike_return_num',
        '电单(租车)': 'e_bike_rent_num',
        '电单(还车)': 'e_bike_return_num',
        '小骑时代(租车)': 'e_bike_rent_num',
        '小骑时代(还车)': 'e_bike_return_num',
        '小遛共享(租车)': 'e_bike_rent_num',
        '小遛共享(还车)': 'e_bike_return_num',
        '悦来美团(租车)': 'e_bike_rent_num',
        '悦来美团(还车)': 'e_bike_return_num',
        '悦来青桔(租车)': 'e_bike_rent_num',
        '悦来青桔(还车)': 'e_bike_return_num'
      }
      const manageMap = {
        '出行(上架)': 'e_bike_up_num',
        '出行(下架)': 'e_bike_down_num',
        '单车(上架)': 'bike_up_num',
        '单车(下架)': 'bike_down_num',
        '电单(上架)': 'e_bike_up_num',
        '电单(下架)': 'e_bike_down_num',
        '小骑时代(上架)': 'e_bike_up_num',
        '小骑时代(下架)': 'e_bike_down_num',
        '小遛共享(上架)': 'e_bike_up_num',
        '小遛共享(下架)': 'e_bike_down_num',
        '悦来美团(上架)': 'e_bike_up_num',
        '悦来美团(下架)': 'e_bike_down_num',
        '悦来青桔(上架)': 'e_bike_up_num',
        '悦来青桔(下架)': 'e_bike_down_num'
      }

      // 先在租还表里找
      let field = Object.keys(rentReturnMap).find(k => name.includes(k))
      if (field) return item[rentReturnMap[field]]

      // 再在上下架表里找
      field = Object.keys(manageMap).find(k => name.includes(k))
      if (field) return item[manageMap[field]]

      return undefined
    },
    originColor(name) {
      return this.brandOriginColor[name]
    },
    eBrandOriginColor(name) {
      return this.eOriginColor[name]
    },
    getColorsByFilterNames() {
      const arr = []
      for (let i = 0, len = this.realNames.length; i < len; i++) {
        const item = this.realNames[i]
        // 区分单车和自行车的颜色
        if (item.indexOf('单车') !== -1) {
          arr.push(this.originColor(item) ? this.originColor(item) : this.getRandomColor())
        } else {
          arr.push(this.eBrandOriginColor(item) ? this.eBrandOriginColor(item) : this.getRandomColor())
        }
      }
      return arr.filter((v) => v)
    },
    color16() {
      var r = Math.floor(Math.random() * 256)
      var g = Math.floor(Math.random() * 256)
      var b = Math.floor(Math.random() * 256)
      var color = '#' + r.toString(16) + g.toString(16) + b.toString(16)
      return color
    },
    getColorsByNames(brandNames) {
      const colorMap = {}
      for (let i = 0, len = brandNames.length; i < len; i++) {
        const item = brandNames[i]
        const newItem = item.slice(0, item.length - 4)
        let color
        // 如果是租还 * 2
        if (this.action === '租还') {
          if (item.indexOf('单车') !== -1) {
            color = this.originColor(newItem) ? this.originColor(newItem) : this.getRandomColor()
          } else {
            color = this.eBrandOriginColor(newItem) ? this.eBrandOriginColor(newItem) : this.getRandomColor()
          }
        } else {
          if (item.indexOf('单车') !== -1) {
            color = this.originColor(newItem) ? this.originColor(newItem) : this.getRandomColor()
          } else {
            color = this.eBrandOriginColor(newItem) ? this.eBrandOriginColor(newItem) : this.getRandomColor()
          }
        }
        colorMap[item] = color
      }
      return colorMap
    },
    getTotalTemperature(data) {
      const temp = {}
      for (const item of data) {
        const key = item.key
        if (!temp[key]) {
          temp[key] = {
            totalZhuCheTemperature: 0,
            totalHuanCheTemperature: 0,
            totalUpTemperature: 0,
            totalDownTemperature: 0
          }
        }
        if (item.city.indexOf('租车') > -1) {
          temp[key].totalZhuCheTemperature += item.temperature || 0
        } else if (item.city.indexOf('还车') > -1) {
          temp[key].totalHuanCheTemperature += item.temperature || 0
        } else if (item.city.indexOf('上架') > -1) {
          temp[key].totalUpTemperature += item.temperature || 0
        } else if (item.city.indexOf('下架') > -1) {
          temp[key].totalDownTemperature += item.temperature || 0
        }
      }
      for (const item of data) {
        item.title = `${this.getTitle(item, temp[item.key])}`
      }
      this.dynamicTotalByTime = temp
      return data
    },
    initScale(id, originDateName, chartName, targetPoint) {
      // 有id表示自定义
      let data = this.getScaleData(originDateName, id, targetPoint)
      data = this.getTotalTemperature(data)
      // 过滤重复的品牌名
      const uniqueCities = [...new Set(data.map(item => item.city))]
      data.sort((a, b) => {
        return a.key - b.key
      })

      // 保存所有数据，供自定义图例过滤 + tooltip 使用
      const allData = data.slice()

      // 当前选中的品牌
      const selectedItems = []

      // 颜色映射
      const colorMap = this.getColorsByNames(uniqueCities)
      // ===== 1. 根据 currentTidalType 决定当前维度的配置 =====
      // pairSuffixes: 该维度下「配对」的两条线后缀
      // defaultSuffix: 默认只展示哪一条
      // legendLabel: 图例文案（仅租车/上架时显示）
      // showLegend: 是否显示图例
      const TIDAL_CONFIG = {
        租车总量: { defaultSuffix: '(租车)', pairSuffixes: ['(租车)', '(还车)'], legendLabel: '(租还)', showLegend: true },
        还车总量: { defaultSuffix: '(还车)', pairSuffixes: ['(还车)'], legendLabel: '', showLegend: false },
        上架总量: { defaultSuffix: '(上架)', pairSuffixes: ['(上架)', '(下架)'], legendLabel: '(调度)', showLegend: true },
        下架总量: { defaultSuffix: '(下架)', pairSuffixes: ['(下架)'], legendLabel: '', showLegend: false }
      }
      // 默认（未点击卡片）：只展示租车，图例文案去掉 (租车)
      const currentConfig = this.currentTidalType
        ? TIDAL_CONFIG[this.currentTidalType]
        : { defaultSuffix: '(租车)', pairSuffixes: ['(租车)'], legendLabel: '', showLegend: true }
      // 取品牌名（去掉后缀）
      const getBrandName = (city) => city.replace(/\((租车|还车|上架|下架)\)$/, '')
      // ===== 2. 曲线数据过滤 =====
      const getChartData = (sourceData, selected) => {
        let list = sourceData
        if (selected && selected.length > 0) {
          // 选中了品牌：展示该品牌在 pairSuffixes 中的所有曲线
          list = list.filter(d =>
            selected.includes(getBrandName(d.city)) &&
            currentConfig.pairSuffixes.some(s => d.city.indexOf(s) > -1)
          )
        } else {
          // 未选中：只展示 defaultSuffix 的单线
          list = list.filter(d => d.city.indexOf(currentConfig.defaultSuffix) > -1)
        }
        return list
      }

      // 构建图表的函数
      const buildChart = (chartData) => {
        if (this[chartName]) {
          this[chartName].destroy()
          this[chartName] = null
        }
        // 没有图例时，把图例占用的高度补给图表
        const LEGEND_HEIGHT = 36
        const hasLegend = currentConfig.showLegend
        const chartHeight = id
          ? 500
          : this.realHeight - 223 + (hasLegend ? 0 : LEGEND_HEIGHT)
        this[chartName] = new Line(id || 'c2', {
          data: chartData,
          height: chartHeight,
          xField: 'month',
          yField: 'temperature',
          seriesField: 'city',
          legend: false,
          point: {
            shape: () => {
              return 'circle'
            },
            color: (datum) => {
              return colorMap[datum.city] || this.color16()
            }
          },
          color: (datum) => {
            return colorMap[datum.city] || this.color16()
          },
          // 添加平滑曲线
          smooth: true,
          // 动画配置 - wave-in 波浪入场效果
          animation: {
            appear: {
              animation: 'wave-in',
              duration: 5000
            }
          },
          lineStyle: ({ city }) => {
            const isElectric =
              city.indexOf('出行') > -1 ||
              city.indexOf('电单') > -1 ||
              city.indexOf('小骑时代') > -1 ||
              city.indexOf('小遛共享') > -1

            // 线宽：包含字眼线宽粗、否则线宽细 lineDash：[3, 1] (虚线)，无为实线
            const width = isElectric ? 3 : 1
            // 租车 / 上架 → 虚线；还车 / 下架 → 实线
            if (city.indexOf('租车') > -1 || city.indexOf('上架') > -1) {
              return { lineWidth: width, lineDash: [3, 1] }
            }
            if (city.indexOf('还车') > -1 || city.indexOf('下架') > -1) {
              return { lineWidth: width }
            }
            return { lineWidth: width }
          },
          tooltip: {
            enterable: true, // ← 允许鼠标进入 tooltip
            customContent: (title, items) => {
              if (!items || !items.length) return ''

              const currentMonth = items[0].data.month
              const currentKey = items[0].data.key
              // 决定 tooltip 展示哪些后缀
              // - 默认状态：全部四个
              // - 点击卡片后：跟随当前曲线（点图例则配对双线，否则单线）
              const allSuffixes = ['(租车)', '(还车)', '(上架)', '(下架)']
              let showSuffixes
              if (!this.currentTidalType) {
                showSuffixes = allSuffixes
              } else {
                showSuffixes = (selectedItems.length > 0)
                  ? currentConfig.pairSuffixes
                  : [currentConfig.defaultSuffix]
              }
              const rawTitle = (items[0] && items[0].data && items[0].data.title) || title
              // 用正则提取：时间 + 四个指标
              const match = rawTitle.match(
                /^(.+?)\s+租车总量：(\S+)\s+还车总量：(\S+)\s+上架总量：(\S+)\s+下架总量：(\S+)$/
              )

              let headerHtml = ''
              if (match) {
                const [, timeLabel, rent, ret, up, down] = match
                const metricMap = {
                  '(租车)': { label: '租车总量', value: rent },
                  '(还车)': { label: '还车总量', value: ret },
                  '(上架)': { label: '上架总量', value: up },
                  '(下架)': { label: '下架总量', value: down }
                }
                const showMetrics = showSuffixes.map(s => metricMap[s]).filter(Boolean)

                let metricsHtml = ''
                for (let i = 0; i < showMetrics.length; i += 2) {
                  const pair = showMetrics.slice(i, i + 2)
                  metricsHtml += '<div style="display:flex;justify-content:space-between;">'
                  pair.forEach(m => {
                    metricsHtml += `<span style="width:50%;">${m.label}：${m.value}</span>`
                  })
                  if (pair.length === 1) {
                    metricsHtml += '<span style="width:50%;"></span>'
                  }
                  metricsHtml += '</div>'
                }

                headerHtml = `
      <div style="margin-bottom:6px;line-height:1.6;">
        <div style="font-weight:bold;margin-top:5px;">${timeLabel}</div>
        ${metricsHtml}
        <div style="border-top:1px solid #e8e8e8;margin:2px 0;"></div>
      </div>`
              }
              // 品牌明细列表
              const getBrandName = (city) => city.replace(/\((租车|还车|上架|下架)\)$/, '')
              const selectedBrands = selectedItems.map(getBrandName)
              let sourceData = allData
              if (selectedBrands.length > 0) {
                sourceData = sourceData.filter(d =>
                  selectedBrands.includes(getBrandName(d.city))
                )
              }

              // 用 showSuffixes 过滤明细
              const pointData = sourceData.filter(
                d => d.month === currentMonth && d.key === currentKey &&
                  showSuffixes.some(s => d.city.indexOf(s) > -1)
              )

              const map = new Map()
              pointData.forEach(d => {
                if (!map.has(d.city)) map.set(d.city, d)
              })
              const list = [...map.values()]

              const orderMap = { '(租车)': 0, '(还车)': 1, '(上架)': 2, '(下架)': 3 }
              const getOrder = (city) => {
                const m = city.match(/\((租车|还车|上架|下架)\)$/)
                return m ? orderMap[m[0]] : 99
              }
              list.sort((a, b) => getOrder(a.city) - getOrder(b.city))

              let itemHtml = ''
              list.forEach(d => {
                const color = colorMap[d.city] || '#ccc'
                itemHtml += `<li class="g2-tooltip-list-item">
      <span class="g2-tooltip-marker" style="background:${color}"></span>
      <span class="g2-tooltip-name">${d.city}</span>:
      <span class="g2-tooltip-value">${d.temperature == null ? 0 : d.temperature}</span>
    </li>`
              })
              return `
    ${headerHtml}
    <div style="max-height:280px;overflow-y:auto;padding-right:4px;">
      <ul class="g2-tooltip-list">${itemHtml}</ul>
    </div>`
            },
            domStyles: {
              'g2-tooltip': {
                transform: 'translateY(-150px)',
                transition: 'transform 0.3s ease-in-out',
                minWidth: '200px'   // 限制宽度
              }
            }
          }
        })

        this[chartName].on('element:click', (event) => {
        // 点击数据
          if (
            event &&
            event.data &&
            event.data.data &&
            event.data.data.temperature
          ) {
            this.onClickPoint(event.data.data)
          }
        })

        this[chartName].render()
        this.loading = false
      }
      // 初始渲染：只展示租车折线
      buildChart(getChartData(allData))
      // 创建自定义图例
      // 图例渲染
      this.$nextTick(() => {
        const chartContainer = document.getElementById(id || 'c2')
        if (!chartContainer) return
        const oldLegend = document.getElementById('tidal-custom-legend-' + (id || 'c2'))
        if (oldLegend) oldLegend.remove()
        // 不显示图例：还车总量 / 下架总量 / 默认状态
        if (!currentConfig.showLegend) return

        const legendContainer = document.createElement('div')
        legendContainer.id = 'tidal-custom-legend-' + (id || 'c2')
        legendContainer.style.display = 'flex'
        legendContainer.style.flexWrap = 'wrap'
        legendContainer.style.alignItems = 'center'
        legendContainer.style.padding = '8px 0'
        legendContainer.style.gap = '5px'
        legendContainer.style.justifyContent = 'flex-start'
        legendContainer.style.lineHeight = '1'
        legendContainer.style.cursor = 'pointer'

        const parent = chartContainer.parentNode
        parent.insertBefore(legendContainer, chartContainer)

        // 图例内容：品牌名 + 维度后缀，如「美团单车(租还)」
        // 取当前维度下配对的两条线对应品牌（去重，只取品牌名）
        const legendCities = uniqueCities.filter(c =>
          currentConfig.pairSuffixes.some(s => c.indexOf(s) > -1)
        )
        const uniqueBrands = [...new Set(legendCities.map(getBrandName))]
        // 取色：用 defaultSuffix 对应的曲线颜色作为品牌色
        const getBrandColor = (brand) =>
          colorMap[brand + currentConfig.defaultSuffix] || '#ccc'
        const renderLegend = () => {
          legendContainer.innerHTML = ''
          uniqueBrands.forEach(brand => {
            const isActive =
              selectedItems.length === 0 || selectedItems.includes(brand)
            const color = getBrandColor(brand)

            const itemDiv = document.createElement('div')
            itemDiv.style.display = 'flex'
            itemDiv.style.alignItems = 'center'
            itemDiv.style.padding = '4px 0'
            itemDiv.style.marginRight = '10px'
            // 展开后高亮，未展开时普通
            itemDiv.style.opacity = '1'
            itemDiv.style.transition = 'all 0.3s ease'

            const marker = document.createElement('span')
            marker.style.display = 'inline-block'
            marker.style.width = '16px'
            marker.style.height = '2px'
            marker.style.marginRight = '8px'
            marker.style.borderRadius = '2px'
            marker.style.backgroundColor = color
            marker.style.transition = 'all 0.3s ease'
            marker.style.flexShrink = '0'
            if (isActive && selectedItems.length > 0) {
              marker.style.boxShadow = `0 0 10px ${color}`
            }

            const text = document.createElement('span')
            // 图例文案：品牌 + 维度后缀（默认无后缀）
            text.textContent = brand + currentConfig.legendLabel
            text.style.color = isActive ? '#333' : 'rgba(0,0,0,0.4)'
            text.style.fontSize = '12px'
            text.style.fontWeight =
              isActive && selectedItems.length > 0 ? 'bold' : 'normal'
            text.style.transition = 'all 0.3s ease'

            itemDiv.appendChild(marker)
            itemDiv.appendChild(text)

            // 点击图例：多选模式切换该品牌的选中状态，改为单选模式
            itemDiv.addEventListener('click', (e) => {
              e.stopPropagation()
              // 如果点的就是当前唯一选中项 → 取消选中（回到全部）
              // 否则 → 只选中当前品牌
              if (selectedItems.length === 1 && selectedItems[0] === brand) {
                selectedItems.length = 0
              } else {
                selectedItems.length = 0
                selectedItems.push(brand)
              }
              buildChart(getChartData(allData, selectedItems))
              renderLegend()
            })
            legendContainer.appendChild(itemDiv)
          })
        }
        renderLegend()
      })
    },
    handleCloseExportLog() {
      this.exportTime = new Date()
      this.pinpai = []
      this.legality = null
      this.exportLogType = null
      this.exportLogAction = '全部'
      this.logData = '5'
      this.$refs['export-log'].onCloseDialog()
    },
    onExportLogShowModel(idx, time) {
      this.exportLogType = idx
      if (time) {
        this.logType = time
      }
      this.$refs['export-log'].onShowDialog()
    },
    async getEnterpriseListAndHasLength() {
      const vm = this
      const params = {}
      params.selfAreaId = vm.selfAreaId
      return new Promise((resolve, reject) => {
        Api.getEnterpriseList(params)
          .then((res) => {
            if (res.code === 200 && res.data && res.data.total) {
              resolve(true)
            } else {
              resolve(false)
            }
          })
          .catch((err) => {
            resolve(false)
            console.log('the getEnterpriseList has probleam: ', err)
          })
      })
    },
    onExportLogPre() {
      const vm = this
      if (!vm.pinpai.length) {
        vm.$message.warning('请先选择品牌！')
        return
      }
      if (!vm.exportTime && vm.exportLogType !== 3) {
        vm.$message.warning('请先选择导出时间！')
        return
      }
      if (vm.exportLogType === 4 && !vm.exportTime[0] && !vm.exportTime[1]) {
        vm.$message.warning('请先选择导出时间！')
        return
      }
      if (vm.logData.length === 0) {
        vm.$message.warning('请先选择导出数据类型！')
        return
      }
      const params = {}
      params.selfAreaId = vm.selfAreaIdOrAggregationId
      Api.getEnterpriseList(params).then((res) => {
        if (res.code === 200) {
          const selectPinpaiIds = []
          vm.pinpai.forEach((item) => {
            res.data.lists.forEach((it) => {
              if (
                item === it.brandName &&
                vm.pinpai.indexOf(it.brandId) === -1
              ) {
                selectPinpaiIds.push(it.brandId)
              }
            })
          })
          if (vm.exportLogType === 1) {
            vm.onExportLogDiaodu(selectPinpaiIds)
          } else if (vm.exportLogType === 2) {
            vm.onExportLog(selectPinpaiIds)
          } else if (vm.exportLogType === 3) {
            vm.onExportBike(selectPinpaiIds)
          } else if (vm.exportLogType === 4) {
            vm.onExportBikeOnline(selectPinpaiIds)
          }
        } else {
          vm.$message.warning(res.message)
        }
      })
    },
    onExportLogDiaodu(selectPinpaiIds) {
      const vm = this
      const formatTime = vm.getSiteParams(vm.exportTime)
      const params = {
        selfAreaId: vm.selfAreaIdOrAggregationId,
        brandIds: selectPinpaiIds.join(','),
        year: formatTime[0]
      }
      if (vm.dataType === '月') {
        params.month = formatTime[1]
      }
      if (vm.dataType === '日') {
        params.month = formatTime[1]
        params.day = formatTime[2]
      }
      if (vm.exportLogAction === '上架') {
        params.action = 1
      }
      if (vm.exportLogAction === '下架') {
        params.action = 2
      }
      const loading = vm.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      Api.reqLogOutDiaodu(params).then((res) => {
        loading.close()
        vm.$message({
          type: 'success',
          message: '数据导出成功！'
        })
        vm.handleCloseExportLog()
        const content = res
        const blob = new Blob([content])
        const fileName = '调度日志导出.xls'
        if ('download' in document.createElement('a')) {
          // 非IE下载
          const elink = document.createElement('a')
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href) // 释放URL 对象
          document.body.removeChild(elink)
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName)
        }
      })
    },
    onExportBikeOnline(selectPinpaiIds) {
      const vm = this
      const params = {
        selfAreaId: vm.selfAreaIdOrAggregationId,
        brandIds: selectPinpaiIds.join(','),
        dataType: vm.logData,
        timeType: vm.logType
      }
      if (vm.logType === '年') {
        if (vm.logData === '4') {
          // 调度时间查询是时间戳
          params.dispatchStartTime = this.dayjs(vm.exportTime[0]).format('YYYY-MM-DD HH:mm:ss')
          params.dispatchEndTime = this.dayjs(vm.exportTime[1]).add(1, 'month').format('YYYY-MM-DD HH:mm:ss')
        }
        params.startTime = this.dayjs(vm.exportTime[0]).format('YYYY-MM')
        params.endTime = this.dayjs(vm.exportTime[1]).format('YYYY-MM')
      }
      if (vm.logType === '月') {
        if (vm.logData === '4') {
          // 调度时间查询是时间戳
          params.dispatchStartTime = this.dayjs(vm.exportTime[0]).format('YYYY-MM-DD HH:mm:ss')
          params.dispatchEndTime = this.dayjs(vm.exportTime[1]).add(1, 'day').format('YYYY-MM-DD HH:mm:ss')
        }
        params.startTime = this.dayjs(vm.exportTime[0]).format('YYYY-MM-DD')
        params.endTime = this.dayjs(vm.exportTime[1]).format('YYYY-MM-DD')
      }
      if (vm.logType === '日') {
        if (vm.logData === '3' || vm.logData === '4') {
          // 调度时间查询是时间戳
          params.dispatchStartTime = this.dayjs(vm.exportTime[0]).minute(0).second(0).format('YYYY-MM-DD HH:mm:ss')
          params.dispatchEndTime = this.dayjs(vm.exportTime[1]).add(1, 'hour').minute(0).second(0).format('YYYY-MM-DD HH:mm:ss')
        }
        params.startTime = this.dayjs(vm.exportTime[0]).format('YYYY-MM-DD HH:mm:ss')
        params.endTime = this.dayjs(vm.exportTime[1]).format('YYYY-MM-DD HH:mm:ss')
      }
      const loading = vm.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      Api.brandBikeOnlinelog(params).then((res) => {
        loading.close()
        vm.$message({
          type: 'success',
          message: '数据导出成功！'
        })
        vm.handleCloseExportLog()
        const content = res
        const blob = new Blob([content])
        const fileName = '车辆定时统计.xls'
        if ('download' in document.createElement('a')) {
          // 非IE下载
          const elink = document.createElement('a')
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href) // 释放URL 对象
          document.body.removeChild(elink)
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName)
        }
      })
    },
    onExportBike(selectPinpaiIds) {
      const vm = this
      const params = {
        selfAreaId: vm.selfAreaIdOrAggregationId,
        brandIds: selectPinpaiIds.join(',')
      }
      if (this.legality !== null) {
        params.legality = this.legality
      }
      const loading = vm.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      Api.sitebikeOut(params).then((res) => {
        loading.close()
        vm.$message({
          type: 'success',
          message: '数据导出成功！'
        })
        vm.handleCloseExportLog()
        const content = res
        const blob = new Blob([content])
        const fileName = '车辆统计.xls'
        if ('download' in document.createElement('a')) {
          // 非IE下载
          const elink = document.createElement('a')
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href) // 释放URL 对象
          document.body.removeChild(elink)
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName)
        }
      })
    },
    onExportLog(selectPinpaiIds) {
      const vm = this
      const params = {
        selfAreaId: vm.selfAreaIdOrAggregationId,
        brandIds: selectPinpaiIds.join(','),
        time: vm.getToday(vm.exportTime)
      }
      const loading = vm.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      Api.reqLogOut(params).then((res) => {
        loading.close()
        vm.$message({
          type: 'success',
          message: '数据导出成功！'
        })
        vm.handleCloseExportLog()
        const content = res
        const blob = new Blob([content])
        const fileName = '潮汐统计.xls'
        if ('download' in document.createElement('a')) {
          // 非IE下载
          const elink = document.createElement('a')
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href) // 释放URL 对象
          document.body.removeChild(elink)
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName)
        }
      })
    },
    // 排名下载
    onExportSite() {
      const vm = this
      const format = vm.getSiteParams(vm.siteRankAllTime)
      const params = {
        selfAreaId: vm.selfAreaIdOrAggregationId,
        year: format[0],
        siteType: vm.siteType,
        orderBy: vm.orderBy
      }
      if (vm.siteType === '时') {
        params.month = format[1]
        params.day = format[2]
        params.hour = format[3]
        params.dateTime = params.year + '-' + params.month + '-' + params.day + '-' + params.hour
      }
      if (vm.siteType === '日') {
        params.month = format[1]
        params.day = format[2]
        params.dateTime = params.year + '-' + params.month + '-' + params.day
      }
      if (vm.siteType === '月') {
        params.month = format[1]
        params.dateTime = params.year + '-' + params.month
      }
      Api.siteRankAllOut(params).then((res) => {
        vm.$message({
          type: 'success',
          message: '数据导出成功！'
        })
        const content = res
        const blob = new Blob([content])
        const fileName = '站点排名分析.xls'
        if ('download' in document.createElement('a')) {
          // 非IE下载
          const elink = document.createElement('a')
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href) // 释放URL 对象
          document.body.removeChild(elink)
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName)
        }
      })
    },
    onSiteRankAllTime() {
      if (!this.siteRankAllTime) {
        this.siteRankAll(true)
      } else {
        this.siteRankAll()
      }
    },
    getSiteParams(data) {
      const vm = this
      const t = data ? vm.getTodayTime(data) : vm.getTodayTime()
      const format = t.split('-')
      return format
    },
    // 排名
    siteRankAll(type) {
      const vm = this
      vm.tableLoading = true
      const format = vm.getSiteParams(vm.siteRankAllTime)
      const params = {
        selfAreaId: vm.selfAreaId,
        year: format[0],
        siteType: vm.siteType,
        orderBy: vm.orderBy
      }
      params.month = format[1]
      params.day = format[2]
      params.hour = format[3]
      params.dateTime = params.year + '-' + params.month + '-' + params.day
      if (vm.siteType === '时') {
        params.startTime = params.year + '-' + params.month + '-' + params.day + ' ' + params.hour + ':00:00'
        params.endTime = params.year + '-' + params.month + '-' + params.day + ' ' + params.hour + ':59:59'
      }
      if (vm.siteType === '日') {
        params.startTime = params.year + '-' + params.month + '-' + params.day + ' 00:00:00'
        params.endTime = params.year + '-' + params.month + '-' + params.day + ' 23:59:59'
      }
      if (vm.siteType === '月') {
        params.startTime = params.year + '-' + params.month + '-01' + ' 00:00:00'
        params.endTime = params.year + '-' + params.month + '-' + params.day + ' 23:59:59'
      }
      Api.siteRankAll(params)
        .then((res) => {
          if (res.code === 200) {
            vm.tableData = res.data
            vm.total = res.data.length
          } else {
            vm.$message.warning(res.message)
          }
          vm.tableLoading = false
        })
        .catch((err) => {
          console.log(err)
          vm.tableLoading = false
        })
    },
    // 站点排名统计排序
    handleSortChange({ column, prop, order }) {
      if (order === 'ascending') {
        if (prop === 'rentNum') {
          this.orderBy = 'rent_num asc'
        } else if (prop === 'returnNum') {
          this.orderBy = 'rent_num asc'
        } else if (prop === 'upNum') {
          this.orderBy = 'up_num asc'
        } else {
          this.orderBy = 'down_num asc'
        }
      } else {
        if (prop === 'rentNum') {
          this.orderBy = 'rent_num desc'
        } else if (prop === 'returnNum') {
          this.orderBy = 'rent_num desc'
        } else if (prop === 'upNum') {
          this.orderBy = 'up_num desc'
        } else {
          this.orderBy = 'down_num desc'
        }
      }
    },
    getTodayTime(date) {
      // 返回 '2020-08-14'
      const day2 = date ? new Date(date) : new Date()
      day2.setTime(day2.getTime())
      return (
        day2.getFullYear() +
        '-' +
        (day2.getMonth() < 9
          ? '0' + (day2.getMonth() + 1)
          : day2.getMonth() + 1) +
        '-' +
        (day2.getDate() < 10 ? '0' + day2.getDate() : day2.getDate()) +
        '-' +
        day2.getHours() +
        '-' +
        day2.getMinutes()
      )
    },
    getToday(date) {
      // 返回 '2020-08-14'
      const day2 = date ? new Date(date) : new Date()
      day2.setTime(day2.getTime())
      return (
        day2.getFullYear() +
        '-' +
        (day2.getMonth() < 9
          ? '0' + (day2.getMonth() + 1)
          : day2.getMonth() + 1) +
        '-' +
        (day2.getDate() < 10 ? '0' + day2.getDate() : day2.getDate())
      )
    },
    getValue(n, total) {
      if (n === 0 || total === 0) {
        return 0
      }
      return Number((Number(Number(n / total).toFixed(3)) * 100).toFixed(1))
    },
    getPinPaiName(originName, type) {
      // originName - 品牌原名，key：1-自行车，2-电动车
      if (type === 1) {
        return originName.slice(1).slice(0, 2) + '单车'
      } else if (type === 2) {
        if (originName.indexOf('美团出行') > -1) {
          return '美团电单(电动车)'
        }
        return originName.slice(1)
      }
      console.log(originName, 'originName')
    },
    getPinpaiSort(data) {
      const list = []
      if (!data) {
        return list
      }
      for (const key in data) {
        list.push(key)
      }
      return list
    },
    initCircle1DataNew() {
      return new Promise((resolve, reject) => {
        const params = {
          selfAreaId: this.selfAreaId
        }
        Api.brandPercentNew(params)
          .then((res) => {
            if (res.code === 200) {
              const cData = []
              const areadata = {
                areaBikeNum: res.data.areaBikeNum,
                areaEleBikeNum: res.data.areaEleBikeNum
              }
              delete res.data.areaBikeNum
              delete res.data.areaEleBikeNum
              this.pinpaiSort = Object.keys(res.data || {})
              const tableData = this.translateData2(res.data)
              this.brandPercentData = res.data
              const onlineTotal = Object.values(tableData).reduce(
                (per, cur) => {
                  if (this.isBicycle) {
                    per += cur.PutBikeNum
                  }
                  if (this.isElectricBike) {
                    per += cur.PutEBikeNum
                  }
                  return per
                },
                0
              ) //  总在线量
              let setCountTotal = 0
              for (const key in tableData) {
                if (!tableData[key]) {
                  continue
                }
                // 保留原始数据
                tableData[key].PutBikeNumOrigin = tableData[key].PutBikeNum
                tableData[key].PutEBikeNumOrigin = tableData[key].PutEBikeNum
                // 数据修正
                tableData[key].PutBikeNum =
                  tableData[key].PutBikeNum <= tableData[key].BrandBikeNum
                    ? tableData[key].PutBikeNum
                    : tableData[key].BrandBikeNum
                tableData[key].PutEBikeNum =
                  tableData[key].PutEBikeNum <= tableData[key].BrandEBikeNum
                    ? tableData[key].PutEBikeNum
                    : tableData[key].BrandEBikeNum
                // 总核定量
                if (this.isBicycle) {
                  setCountTotal += tableData[key].BrandBikeNum
                }
                if (this.isElectricBike) {
                  setCountTotal += tableData[key].BrandEBikeNum
                }
                const curData = tableData[key]
                // 单车数据集
                if (this.isBicycle) {
                  const tempBike = {
                    type: this.getPinPaiName(key, 1), // key + '(单车)',
                    key: 1,
                    bili: this.getValue(
                      // 在线量占比
                      curData.PutBikeNumOrigin,
                      onlineTotal
                    ),
                    percent: this.getValue(
                      curData.PutBikeNumOrigin,
                      curData.BrandBikeNum
                    ),
                    online: curData.PutBikeNumOrigin,
                    inSite: curData.SiteBikeNum,
                    setCount: curData.BrandBikeNum
                  }
                  if (tempBike.online + tempBike.setCount > 0) {
                    cData.push(tempBike)
                    this.realNames.push(this.getPinPaiName(key, 1))
                  }
                }
                // 电车数据集
                if (this.isElectricBike) {
                  const tempEBike = {
                    type: this.getPinPaiName(key, 2), // key + '(电动车)',
                    key: 2,
                    bili: this.getValue(
                      // 在线量占比
                      curData.PutEBikeNumOrigin,
                      onlineTotal
                    ),
                    percent: this.getValue(
                      // 在线量占比
                      curData.PutEBikeNumOrigin,
                      curData.BrandEBikeNum
                    ),
                    online: curData.PutEBikeNumOrigin,
                    inSite: curData.SiteEBikeNum,
                    setCount: curData.BrandEBikeNum
                  }
                  if (tempEBike.online + tempEBike.setCount > 0) {
                    cData.push(tempEBike)
                    this.realNames.push(this.getPinPaiName(key, 2))
                  }
                }
              }
              let total = 0
              // 用户账号属性为自行车
              if (this.userBikeType === 0) {
                total = (areadata.areaBikeNum || 0)
                // 用户账号属性为电动车
              } else if (this.userBikeType === 1) {
                total = (areadata.areaEleBikeNum || 0)
                // 用户账号属性包括自行车及电动车
              } else {
                total = (areadata.areaBikeNum || 0) + (areadata.areaEleBikeNum || 0)
              }
              let percent = 0
              if (total) {
                percent = Number(Number(setCountTotal / total).toFixed(2))
              }
              const c3Data = [
                {
                  item: '核定量',
                  count: setCountTotal,
                  percent
                },
                {
                  item: '未核定量',
                  count: total - setCountTotal,
                  percent: 1 - percent
                }
              ]

              try {
                // 在此运行代码
                this.initCircle1(cData, onlineTotal)
                this.initCircle3(c3Data, total)
              } catch (err) {
                // 在此处理错误
                console.log('c3', err)
              }
            } else {
              this.$message.warning(res.message)
            }
            resolve(true)
          })
          .catch((err) => {
            console.log('the initCircle1Data has problem', err)
            reject(err)
          })
      })
    },
    getRandomColor() {
      return '#' + ((Math.random() * 0xffffff) << 0).toString(16)
    },
    initCircle1(cData, total, realNamesNumber) {
      const vm = this
      // 可以通过调整这个数值控制分割空白处的间距，0-1 之间的数值
      const sliceNumber = 0.002
      // 自定义 other 的图形，增加两条线
      registerShape('interval', 'slice-shape', {
        draw(cfg, container) {
          const points = cfg.points
          let path = []
          path.push(['M', points[0].x, points[0].y])
          path.push(['L', points[1].x, points[1].y - sliceNumber])
          path.push(['L', points[2].x, points[2].y - sliceNumber])
          path.push(['L', points[3].x, points[3].y])
          path.push('Z')
          path = this.parsePath(path)
          return container.addShape('path', {
            attrs: {
              fill: cfg.color,
              path
            }
          })
        }
      })
      if (vm.Circle1) {
        vm.Circle1.destroy()
        vm.Circle1 = null
      }
      // 清空容器，避免残留
      const container = document.getElementById('c1')
      if (!container) return
      container.innerHTML = ''

      // 保存全量数据
      const allData = cData.slice()
      // 当前选中的品牌名称数组
      let selectedItems = []
      // 颜色映射表：按 type 记录颜色，保证图例和饼图颜色一致
      const colorArr = this.getColorsByFilterNames()
      colorArr.push('#F5F5F5')
      colorArr.push('#D9D9D9')
      const colorMap = {}
      allData.forEach((d, i) => {
        colorMap[d.type] = colorArr[i] || vm.getRandomColor()
      })

      const buildSegments = (list) => {
        const segments = []
        list.forEach((d, i) => {
          const percent = Number(d.percent) || 0
          const baseColor = colorMap[d.type] || vm.getRandomColor()
          const deepColor = vm.darkenColor(baseColor, 0.25)

          // 新增：整段 label 的 HTML，超标时整体闪烁
          const labelHtml = percent > 100
            ? `<span style="font-weight:bold;color:#f5222d;animation:tidal-percent-blink 0.8s infinite;">${d.type}: ${percent}%</span>`
            : `<span style="font-weight:bold;color:#000;">${d.type}: ${percent}%</span>`

          if (percent <= 100) {
            segments.push({
              ...d,
              labelHtml,// 新增
              segKey: d.type + '_normal',
              segType: d.type,
              segColor: baseColor,
              bili: d.bili
            })
          } else {
            const normalRatio = 100 / percent
            const overRatio = (percent - 100) / percent

            segments.push({
              ...d,
              labelHtml,// 新增
              segKey: d.type + '_normal',
              segType: d.type,
              segColor: baseColor,
              bili: d.bili * normalRatio
            })
            segments.push({
              ...d,
              labelHtml,// 新增
              segKey: d.type + '_over',
              segType: d.type,
              segColor: deepColor,
              bili: d.bili * overRatio,
              isOver: true
            })
          }
        })
        return segments
      }

      // 构建图表
      function buildChart(data) {
        if (vm.Circle1) {
          vm.Circle1.destroy()
          vm.Circle1 = null
        }
        const containerEl = document.getElementById('c1')
        if (containerEl) {
          containerEl.innerHTML = ''
        }
        const segData = buildSegments(data)
        vm.Circle1 = new Chart({
          container: 'c1',
          autoFit: true,
          height: 230
        })

        vm.Circle1.data(segData)
        vm.Circle1.coordinate('theta', {
          radius: 0.75,
          innerRadius: 0.6
        })
        // 禁用默认图例
        vm.Circle1.legend(false)
        vm.Circle1.tooltip({
          showTitle: false,
          showMarkers: false,
          itemTpl: `<li class="g2-tooltip-list-item">
      <span style="background-color:{segColor};" class="g2-tooltip-marker"></span>
      {labelHtml}
      <p style="margin-top:10px;margin-left:20px;color:#999;">在线量{online}辆</p>
      <p style="margin-top:10px;margin-left:20px;color:#999;">核定量{setCount}辆</p>
      <p style="margin-top:10px;margin-left:20px;color:#999;">站点车辆{inSite}辆</p>
    </li>`
        })
        // 中间文字：根据选中情况动态变化
        let centerText = '总在线量'
        let centerValue = total
        if (selectedItems.length === 1) {
          centerText = selectedItems[0]
          // 找到选中品牌的在线量
          const selectedItem = allData.find(item => item.type === selectedItems[0])
          if (selectedItem) {
            centerValue = selectedItem.online
          }
        }

        vm.Circle1.annotation()
          .text({
            position: ['50%', '50%'],
            content: centerValue,
            style: {
              fontSize: 28,
              fill: '#000',
              textAlign: 'center'
            },
            offsetY: -10
          })
          .text({
            position: ['50%', '50%'],
            content: centerText,
            style: {
              fontSize: 14,
              fill: '#8c8c8c',
              textAlign: 'center'
            },
            offsetX: 0,
            offsetY: 20
          })
        const hasSelection = selectedItems.length > 0
        vm.Circle1.interval()
          .style({
            stroke: 'white',
            lineWidth: 1
          })
          .adjust('stack')
          .position('bili')
          .color('segKey', (segKey) => {
            // 找到对应 segment 的颜色
            const seg = segData.find(s => s.segKey === segKey)
            const baseColor = seg ? seg.segColor : '#ccc'
            const segType = seg ? seg.segType : ''

            // 没有选中：全部正常显示
            if (!hasSelection) return baseColor
            // 选中项：正常颜色
            if (selectedItems.includes(segType)) return baseColor
            // 未选中项：浅灰
            return '#E8E8E8'
          })
          .tooltip(
            'segType*percent*labelHtml*online*inSite*setCount*segColor',
            (segType, percent, labelHtml, online, inSite, setCount, segColor) => ({
              segType, percent, labelHtml, online, inSite, setCount, segColor
            })
          )
          .shape('slice-shape')

        vm.Circle1.render()
      }

      // 初始渲染
      buildChart(allData)

      // 创建自定义图例
      this.$nextTick(() => {
        const containerEl = document.getElementById('c1')
        if (!containerEl) return

        const oldLegend = document.getElementById('c1-legend-container')
        if (oldLegend) {
          oldLegend.remove()
        }

        const legendContainer = document.createElement('div')
        legendContainer.id = 'c1-legend-container'
        legendContainer.style.display = 'flex'
        legendContainer.style.flexWrap = 'wrap'
        legendContainer.style.justifyContent = 'center'
        legendContainer.style.alignItems = 'center'
        legendContainer.style.padding = '8px 0'
        legendContainer.style.width = '100%'
        legendContainer.style.marginTop = '-20px'

        function renderLegend() {
          legendContainer.innerHTML = ''

          allData.forEach((d) => {
            const type = d.type
            const isActive =
              selectedItems.length === 0 || selectedItems.includes(type)
            const isHighlighted = selectedItems.length > 0 && isActive
            const color = colorMap[type] || '#ccc'
            // 判断总量是否超过 100%
            const isOver = Number(d.percent) > 100
            const itemDiv = document.createElement('div')
            itemDiv.style.display = 'flex'
            itemDiv.style.alignItems = 'center'
            itemDiv.style.cursor = 'pointer'
            itemDiv.style.userSelect = 'none'
            itemDiv.style.opacity = isActive ? '1' : '0.4'
            itemDiv.style.transition = 'all 0.3s ease'
            itemDiv.style.padding = '4px 8px'
            itemDiv.style.borderRadius = '4px'
            // 超过 100% 时，整个图例项闪烁
            if (isOver) {
              itemDiv.style.animation = 'legend-blink 0.8s infinite'
            }

            // 颜色圆点
            const marker = document.createElement('span')
            marker.style.width = '10px'
            marker.style.height = '10px'
            marker.style.display = 'inline-block'
            marker.style.marginRight = '6px'
            marker.style.borderRadius = '50%'
            marker.style.backgroundColor = color
            marker.style.transition = 'all 0.3s ease'
            marker.style.flexShrink = '0'
            if (isHighlighted) {
              marker.style.boxShadow = `0 0 12px ${color}`
            }

            // 文字
            const text = document.createElement('span')
            text.textContent = type
            text.style.color = isActive ? '#050505' : '#000000'
            text.style.fontSize = '12px'
            text.style.fontWeight = isHighlighted ? 'bold' : 'normal'
            text.style.transition = 'all 0.3s ease'
            // 超过 100% 时文字闪烁
            if (isOver) {
              text.style.animation = 'legend-text-blink 0.8s infinite'
            }
            itemDiv.appendChild(marker)
            itemDiv.appendChild(text)

            itemDiv.addEventListener('click', function (e) {
              e.stopPropagation()
              // 单选逻辑：点击已选中项则取消，否则替换为当前项
              if (selectedItems.length === 1 && selectedItems[0] === type) {
                selectedItems = []
              } else {
                selectedItems = [type]
              }
              // 过滤数据：有选中就只显示选中的项
              let newData
              if (selectedItems.length === 0) {
                newData = allData
              } else {
                newData = allData.filter((item) =>
                  selectedItems.includes(item.type)
                )
              }
              renderLegend()
              buildChart(newData)
            })

            legendContainer.appendChild(itemDiv)
          })
        }

        // 插到 c1 容器后面
        containerEl.parentNode.insertBefore(
          legendContainer,
          containerEl.nextSibling
        )
        renderLegend()
      })
    },
    darkenColor(hex, amount = 0.25) {
      const c = hex.replace('#', '')
      const num = parseInt(c.length === 3
        ? c.split('').map(x => x + x).join('')
        : c, 16)
      let r = (num >> 16) & 0xff
      let g = (num >> 8) & 0xff
      let b = num & 0xff
      r = Math.max(0, Math.floor(r * (1 - amount)))
      g = Math.max(0, Math.floor(g * (1 - amount)))
      b = Math.max(0, Math.floor(b * (1 - amount)))
      return '#' + [r, g, b].map(v => v.toString(16).padStart(2, '0')).join('')
    },
    initCircle3(cData, total) {
      const vm = this
      if (vm.Circle3) {
        vm.Circle3.destroy()
        vm.Circle3 = null
      }
      // 清空容器
      const container = document.getElementById('c3')
      if (!container) return
      container.innerHTML = ''
      // 存储所有数据
      const allData = cData.slice()
      // 当前选中的图例名称数组
      const selectedItems = []

      // 构建图表的函数
      function buildChart(data) {
        if (vm.Circle3) {
          vm.Circle3.destroy()
          vm.Circle3 = null
        }
        const containerEl = document.getElementById('c3')
        if (containerEl) {
          containerEl.innerHTML = ''
        }
        vm.Circle3 = new Chart({
          container: 'c3',
          autoFit: true,
          height: 220
        })
        const chartTotal = data.reduce((sum, item) => sum + item.count, 0)

        vm.Circle3.data(data)
        vm.Circle3.scale('percent', {
          formatter: (val) => {
            val = Math.round(val * 100) + '%'
            return val
          }
        })
        vm.Circle3.coordinate('theta', {
          radius: 0.75,
          innerRadius: 0.6
        })
        // 禁用默认图例
        vm.Circle3.legend(false)
        vm.Circle3.tooltip({
          showTitle: false,
          showMarkers: false,
          itemTpl: `
        <li class="g2-tooltip-list-item">
          <span style="background-color:{color};" class="g2-tooltip-marker"></span>
          <span style="font-weight:bold;color:#000;">{name}: {value}</span>
          <p style="margin-top:10px;margin-left:20px;color:#999;">{name}: {count}辆</p>
        </li>`
        })
        // 控制饼图中间文字显示
        let centerText = '城市总量'
        if (selectedItems.length === 1) {
          if (selectedItems[0] === '核定量') {
            centerText = '核定总量'
          } else if (selectedItems[0] === '未核定量') {
            centerText = '未核定总量'
          }
        }

        vm.Circle3.annotation()
          .text({
            position: ['50%', '50%'],
            content: chartTotal,
            style: {
              fontSize: 28,
              fill: '#000',
              textAlign: 'center'
            },
            offsetY: -10
          })
          .text({
            position: ['50%', '50%'],
            content: centerText,
            style: {
              fontSize: 14,
              fill: '#8c8c8c',
              textAlign: 'center'
            },
            offsetX: 0,
            offsetY: 20
          })
        const hasSelection = selectedItems.length > 0
        vm.Circle3.interval()
          .adjust('stack')
          .position('percent')
          .color('item', (item) => {
            // 如果没有选中任何项，全部显示
            if (!hasSelection) {
              return item === '核定量' ? '#1890ff' : '#aacdea'
            }
            // 如果当前项被选中，显示其对应的颜色
            if (selectedItems.includes(item)) {
              return item === '核定量' ? '#1890ff' : '#aacdea'
            }
            // 未被选中：显示为浅灰色（表示隐藏）
            return '#E8E8E8'
          })
          .tooltip('item*count*percent', (item, count, percent) => {
            return {
              name: item,
              value: Math.round(percent * 100) + '%',
              count
            }
          })
        vm.Circle3.render()
      }
      // 初始构建
      buildChart(allData)
      // 创建自定义图例
      this.$nextTick(() => {
        const containerEl = document.getElementById('c3')
        if (!containerEl) return

        const oldLegend = document.getElementById('c3-legend-container')
        if (oldLegend) {
          oldLegend.remove()
        }

        const legendContainer = document.createElement('div')
        legendContainer.id = 'c3-legend-container'
        legendContainer.style.display = 'flex'
        legendContainer.style.justifyContent = 'center'
        legendContainer.style.alignItems = 'center'
        legendContainer.style.padding = '8px 0'
        legendContainer.style.gap = '20px'
        legendContainer.style.width = '100%'
        function renderLegend() {
          legendContainer.innerHTML = ''

          allData.forEach((d) => {
            // 判断是否激活：没有选中任何项 或 当前项在选中列表中
            const isActive = selectedItems.length === 0 || selectedItems.includes(d.item)
            // 判断是否高亮：有选中项且当前项被选中
            const isHighlighted = selectedItems.length > 0 && isActive

            // 核定量：蓝色 #1890ff；未核定量：浅蓝色 #aacdea
            const color = d.item === '核定量' ? '#1890ff' : '#aacdea'

            const itemDiv = document.createElement('div')
            itemDiv.style.display = 'flex'
            itemDiv.style.alignItems = 'center'
            itemDiv.style.cursor = 'pointer'
            itemDiv.style.userSelect = 'none'
            // 未激活时透明度0.9，激活时1
            itemDiv.style.opacity = isActive ? '1' : '0.9'
            itemDiv.style.transition = 'all 0.3s ease'
            itemDiv.style.padding = '4px 12px'
            itemDiv.style.borderRadius = '4px'
            itemDiv.style.position = 'relative'
            itemDiv.style.height = '15px'
            // 颜色标记
            const marker = document.createElement('span')
            marker.style.width = '10px'
            marker.style.height = '10px'
            marker.style.display = 'inline-block'
            marker.style.marginRight = '8px'
            marker.style.borderRadius = '50%'
            marker.style.backgroundColor = color
            marker.style.transition = 'all 0.3s ease'
            marker.style.flexShrink = '0'
            // 选中时发光效果
            if (isHighlighted) {
              marker.style.boxShadow = `0 0 12px ${color}`
              marker.style.transform = 'scale(1.0)'
            }
            // 图例文字
            const text = document.createElement('span')
            text.textContent = d.item
            text.style.color = isHighlighted ? (d.item === '核定量' ? '#1890ff' : '#aacdea') : 'rgba(0,0,0,0.8)'
            text.style.fontSize = '12px'
            text.style.fontWeight = isHighlighted ? 'bold' : 'normal'
            text.style.transition = 'all 0.3s ease'
            text.style.display = 'inline-block'
            // 显示数量
            const countText = document.createElement('span')
            countText.textContent = ` (${d.count}辆)`
            countText.style.color = isActive ? 'rgba(0,0,0,0.45)' : 'rgba(0,0,0,0.3)'
            countText.style.fontSize = '12px'
            countText.style.marginLeft = '4px'

            itemDiv.appendChild(marker)
            itemDiv.appendChild(text)
            itemDiv.appendChild(countText)
            // 点击事件
            itemDiv.addEventListener('click', function(e) {
              e.stopPropagation()
              const index = selectedItems.indexOf(d.item)
              if (index > -1) {
                // 如果已选中，取消选中
                selectedItems.splice(index, 1)
              } else {
                // 如果未选中，添加到选中列表
                selectedItems.push(d.item)
              }
              // 更新图表数据
              let newData
              if (selectedItems.length === 0) {
                // 没有选中任何项，显示全部
                newData = allData
              } else {
                // 只显示被选中的项
                newData = allData.filter(item => selectedItems.includes(item.item))
              }
              renderLegend()
              buildChart(newData)
            })
            legendContainer.appendChild(itemDiv)
          })
        }

        containerEl.parentNode.insertBefore(legendContainer, containerEl.nextSibling)
        renderLegend()
      })
    },
    // 合并租还 + 上下架数据
    mergeTidalData(rentReturnData, upDownData) {
      const merged = {}
      const allBrands = new Set([
        ...Object.keys(rentReturnData),
        ...Object.keys(upDownData)
      ])
      // 日：date + hour；月 / 年：只用 date（忽略 hour）
      const buildKey = (item) => {
        const date = item.date || ''
        if (this.dataType === '日') {
          return `${date}_${item.hour != null ? item.hour : ''}`
        }
        return date
      }
      allBrands.forEach(brandKey => {
        const rentList = rentReturnData[brandKey] || []
        const upDownList = upDownData[brandKey] || []
        const map = new Map()
        rentList.forEach(item => {
          map.set(buildKey(item), { ...item })
        })
        upDownList.forEach(item => {
          const key = buildKey(item)
          if (map.has(key)) {
            Object.assign(map.get(key), {
              bike_up_num: item.bike_up_num,
              bike_down_num: item.bike_down_num,
              e_bike_up_num: item.e_bike_up_num,
              e_bike_down_num: item.e_bike_down_num
            })
          } else {
            map.set(key, { ...item })
          }
        })
        merged[brandKey] = [...map.values()]
      })
      return merged
    },
    // 统计四类总量
    translateTotalDynamicData(data) {
      let rentData = 0
      let returnData = 0
      let upData = 0
      let downData = 0
      for (const pinpaiName in data) {
        const pinpai = data[pinpaiName]
        for (const p of pinpai) {
          if (this.isBicycle) {
            rentData += p.bike_rent_num || 0
            returnData += p.bike_return_num || 0
            upData += p.bike_up_num || 0
            downData += p.bike_down_num || 0
          }
          if (this.isElectricBike) {
            rentData += p.e_bike_rent_num || 0
            returnData += p.e_bike_return_num || 0
            upData += p.e_bike_up_num || 0
            downData += p.e_bike_down_num || 0
          }
        }
      }
      this.dynamicAllToatal.rent = rentData
      this.dynamicAllToatal.return = returnData
      this.dynamicAllToatal.up = upData
      this.dynamicAllToatal.down = downData
    },
    // 生成四个总量卡片数据
    getTotalDynamicDataShow() {
      this.dynamicTotalShowData = [
        { name: '租车总量', from: 0, to: this.dynamicAllToatal.rent, duration: 6000 },
        { name: '还车总量', from: 0, to: this.dynamicAllToatal.return, duration: 6000 },
        { name: '上架总量', from: 0, to: this.dynamicAllToatal.up, duration: 6000 },
        { name: '下架总量', from: 0, to: this.dynamicAllToatal.down, duration: 6000 }
      ]
    },
    // 跳转至企业管理——租还信息页面
    goRequestSyncPage(path, query) {
      if (this.selfAreaId) {
        this.$router.push({
          name: path,
          params: { id: this.selfAreaId, ...query }
        })
      }
    },
    onSwitchTidalType(name) {
      // 再次点击同一个，取消筛选，回到默认（现有曲线）
      if (this.currentTidalType === name) {
        this.currentTidalType = null
      } else {
        this.currentTidalType = name
      }
      this.renderTidalChart()
    },
    // 统一负责重绘主折线图
    renderTidalChart() {
      if (this.chart) {
        this.chart.destroy()
        this.chart = null
      }
      this.$nextTick(() => {
        this.initScale(null, 'tidalData', 'chart', null)
      })
    }
  },
  components: {
    WTable,
    WDialog,
    AnimateNumber,
    totalSumChart
  }
}
</script>

<style lang="less">
/* 非 scoped，总在线量tooltip 挂在 body 上 */
@keyframes tidal-percent-blink {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.15; }
}
// 总在线量-图例闪烁
@keyframes legend-text-blink {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.15; }
}

@keyframes legend-marker-blink {
  0%, 100% { opacity: 1; transform: scale(1); }
  50% { opacity: 0.2; transform: scale(0.7); }
}
</style>
<style lang="less" scoped>
.datestyle {
  vertical-align: middle;
  width: 125px !important;
}

.datestyle input {
  padding-right: 0px !important;
}

.datestyle2 .el-time-panel {
  width: 100px !important;
}

.datestyle2 .el-time-panel .el-time-panel__content {
  text-align: center !important;
}

.datestyle2
.el-time-panel
.el-time-panel__content
.el-time-spinner
.el-time-spinner__wrapper:nth-child(2)
.el-scrollbar__wrap
ul
li {
  color: #fff;
}

.datestyle2
.el-time-panel
.el-time-panel__content
.el-time-spinner
.el-time-spinner__wrapper:first-child
.el-scrollbar__wrap
ul {
  text-align: right;
}

.table-height-limit {
  .el-table td,
  .el-table th {
    padding: 3px 0;
  }
}
</style>
<style lang="less" scoped>
.layout {
  background: #f0f2f5;
}

.dynamic-show {
  width: 100%;
  display: flex;
  margin-top: 20px;
  margin-bottom: 30px;
  text-align: center;

  & > div.dynamic-item {
    flex: 1;
    border: 1px solid #ebebeb;
    padding: 20px 0;
    margin-left: -1px;
    cursor: pointer; // 鼠标小箭头变小手
    transition: all 0.3s ease; // 加过渡，选中时更顺滑

    .num {
      line-height: 1;
      font-size: 20px;
      margin-bottom: 6px;
      color: rgba(0, 0, 0, 0.85);

      &.blue {
        font-size: 20px;
        font-weight: bold;
        color: #1f8ffb;
      }
    }

    .name {
      line-height: 1;
      font-size: 12px;
      color: rgba(0, 0, 0, 0.45);
    }
    // 选中态：边框高亮 + 背景浅蓝 + 数字变蓝
    &.active-total {
      border-color: #1f8ffb;
      background-color: #f0f7ff;
      z-index: 1;// 避免被相邻边框盖住

      .num {
        color: #1f8ffb;
        font-weight: bold;
      }
      .name {
        color: #1f8ffb;
      }
    }
    // 悬浮态：轻微选中效果
    &:hover {
      border-color: #b3d8ff;
      background-color: #fafcff;
      z-index: 1;
    }
  }

  & + .dynamic-show {
    margin-top: -31px;
  }
}

.blue {
  color: #409eff;
}

.pointer {
  cursor: pointer;
}

.inlineBlock {
  display: inline-block;
  vertical-align: bottom;
}

.flex {
  display: flex;
}

.flex1 {
  flex: 1;
}

.flex2 {
  flex: 2;
}

.justbetween {
  justify-content: space-between;
  align-items: center;
}

.border-r-4 {
  border-radius: 8px;
}

.bg-f {
  background-color: #fff;
}

.p16 {
  padding: 16px;
}

.mr12 {
  margin-right: 12px;
}

.mr16 {
  margin-right: 16px;
}

.mt16 {
  margin-top: 16px;
}

.w100 {
  width: 100%;
}

.c-blue {
  color: #1ca0ff;
}

.mr10 {
  margin-right: 10px;
}

.mb20 {
  margin-bottom: 20px;
}

.mb10 {
  margin-bottom: 10px;
}

.mr20 {
  margin-right: 20px;
}

.w120 {
  width: 120px;
}

.fs14 {
  font-size: 14px;
}

.bold {
  font-weight: bold;
}

.c0 {
  color: #000;
}

.table-height-limit {
  height: 220px;
  overflow-y: scroll;

  .el-table td,
  .el-table th {
    padding: 3px 0;
  }
}

.w70 {
  width: 70px;
}

.mr2 {
  margin-right: 8px;
}
// 深度选择器修改内部元素样式
.site_ranking_table ::v-deep .el-table__cell.is-center {
  padding: 5px 5px;
}
</style>
